import { __extends } from "tslib";
import { Point } from '@awayjs/core';
import { FilterUtils } from '../../utils/FilterUtils';
import { MultipleUVTask } from './webgl/MultipleUVTask';
var FRAG = function (_a) {
    var _b = _a.compX, compX = _b === void 0 ? 0 : _b, _c = _a.compY, compY = _c === void 0 ? 1 : _c, _d = _a.mode, mode = _d === void 0 ? 'wrap' : _d;
    return "\nprecision highp float;\n\n// source\nuniform sampler2D fs0;\n// map\nuniform sampler2D fs1;\nuniform vec2 uMapPoint;\nuniform vec2 uScale;\n" + (mode === 'color' ? 'uniform vec4 uColor;' : '') + "\n\nvarying vec2 vUv[2];\nvarying vec4 vUvLim[2];\n\nvoid main() {\n\tvec4 map = texture2D(fs1, vUv[1] - uMapPoint);\n\tvec2 offset = vec2(map[" + (compX | 0) + "] - 0.5, map[" + (compY | 0) + "] - 0.5) * uScale * 2.0; \n\n\tvec2 uv = vUv[0] + offset;\n\n\t// invalid, we must remap onto vUvLim[0]\n\t" + (!mode || mode === 'wrap' ? 'uv = fract(uv);' : '') + "\n\t" + (mode === 'clamp' ? 'uv = clamp(uv, vUvLim[0].xy, vUvLim[0].zw);' : '') + "\n\n\t" + (mode === 'ignore' ? 'uv = vUv;' : '') + "\n\t" + (mode === 'color'
        ? 'bool outside = uv.x < 0. || uv.x > 1. || uv.y < 0. || uv.y > 1.;'
        : '') + "\n\n\t" + (mode === 'color'
        ? 'gl_FragColor = outside ? uColor : texture2D(fs0, uv);'
        : 'gl_FragColor = texture2D(fs0, uv);') + "\n\t\n\t//gl_FragColor = map;\n}\n\n";
};
var DisplacementTask = /** @class */ (function (_super) {
    __extends(DisplacementTask, _super);
    function DisplacementTask() {
        var _this = 
        // source + map and limits
        _super.call(this, 2, true) || this;
        _this.mode = 'wrap';
        _this.componentX = 1;
        _this.componentY = 2;
        _this.mapPoint = new Point(0, 0);
        _this._uColor = [0, 0, 0, 0];
        _this._color = 0x0;
        _this._alpha = 0x0;
        _this.scaleX = 1;
        _this.scaleY = 1;
        return _this;
    }
    Object.defineProperty(DisplacementTask.prototype, "isValid", {
        get: function () {
            return this.mapBitmap && !this.mapBitmap.isDisposed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplacementTask.prototype, "color", {
        get: function () {
            return this._color;
        },
        set: function (value) {
            if (this._color === value)
                return;
            this._color = value;
            FilterUtils.colorToArray(this._color, this._alpha, this._uColor);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplacementTask.prototype, "alpha", {
        get: function () {
            return this._alpha;
        },
        set: function (value) {
            if (this._alpha === value)
                return;
            this._alpha = value;
            this._uColor[3] = this._alpha;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplacementTask.prototype, "name", {
        get: function () {
            return "Displacement:" + this.mode + ":" + this.componentX + ":" + this.componentY;
        },
        enumerable: false,
        configurable: true
    });
    DisplacementTask.prototype.getFragmentCode = function () {
        return FRAG({
            compX: Math.log2(this.componentX),
            compY: Math.log2(this.componentY),
            mode: this.mode
        });
    };
    DisplacementTask.prototype.activate = function (_stage, _projection, _depthTexture) {
        _super.prototype.computeVertexData.call(this);
        var input = this.inputRect;
        var output = this.destRect;
        var map = this.mapBitmap;
        var p = this._program3D;
        // UV for displacementMap
        this.uvMatrices[1].set([
            0, 0,
            map.width / output.width,
            map.height / output.height,
        ], 0);
        this.uploadVertexData();
        p.uploadUniform('uScale', [
            this.scaleX / input.width,
            this.scaleY / input.height
        ]);
        p.uploadUniform('uMapPoint', [
            this.mapPoint.x / map.width,
            this.mapPoint.y / map.height
        ]);
        if (this.mode === 'color') {
            p.uploadUniform('uColor', this._uColor);
        }
        this.mapBitmap.getAbstraction(_stage).activate(1);
    };
    return DisplacementTask;
}(MultipleUVTask));
export { DisplacementTask };
